import Bullet from "./Bullet";
import styled from "styled-components";
import Button from "./Button";

const DifficultyContainer = styled.div`
  display: flex;
  border-radius: 12px;
  font-size: 14px;
  background: #f1f1f1;
  align-items: center;
  padding: 4px 0 4px 8px;

  > span {
    padding-right: 5px;
  }

  ${Bullet} {
    margin-right: 4px;
  }
`;

export default ({
  current = 0,
  levels = 4,
  switchDifficulty = (level: number) => {},
}) => {
  const levelSlots = Array.from(Array(levels)).map((el, index) => index + 1);
  return (
    <DifficultyContainer>
      <span>Schwierigkeitsgrad:</span>
      {levelSlots.map((level) => {
        return (
          <Button
            onClick={() => switchDifficulty(level)}
            key={level}
            active={current === level}
          >
            {level}
          </Button>
        );
      })}
    </DifficultyContainer>
  );
};
